import { Chip } from "@material-ui/core";
import { blue, blueGrey, green, orange } from "@material-ui/core/colors";
import React from "react";

export default function StatusLabel({ status }) {
  switch (status) {
    case 10:
      return (
        <Chip
          size="small"
          label="DRAFT"
          style={{
            backgroundColor: blueGrey[600],
            color: "white",
          }}
        />
      );
    case 20:
      return (
        <Chip
          size="small"
          label="POST"
          style={{
            backgroundColor: blue[600],
            color: "white",
          }}
        />
      );
    case 22:
      return (
        <Chip
          size="small"
          label="REVIEWED"
          style={{
            backgroundColor: blue[600],
            color: "white",
          }}
        />
      );
    case 24:
      return (
        <Chip
          size="small"
          label="REJECTED BY REVIEWER"
          style={{
            backgroundColor: blue[600],
            color: "white",
          }}
        />
      );
    case 26:
      return (
        <Chip
          size="small"
          label="HELD BY REVIEWER"
          style={{
            backgroundColor: blue[600],
            color: "white",
          }}
        />
      );
    case 30:
      return (
        <Chip
          size="small"
          label="MANAGER APPROVED"
          style={{
            backgroundColor: green[600],
            color: "white",
          }}
        />
      );
    case 35:
      return (
        <Chip
          size="small"
          label="HELD BY APPROVER"
          style={{
            backgroundColor: orange[600],
            color: "white",
          }}
        />
      );
    case 40:
      return (
        <Chip
          size="small"
          label="MANAGER REJECTED"
          style={{
            backgroundColor: "red",
            color: "white",
          }}
        />
      );
    case 49:
      return (
        <Chip
          size="small"
          label="CONTRACT IS REQUIRED"
          style={{
            backgroundColor: "yellow",
          }}
        />
      );
    case 50:
      return (
        <Chip
          size="small"
          label="PURCHASING  IN PROGRESS"
          style={{
            backgroundColor: "yellow",
          }}
        />
      );
    case 51:
      return (
        <Chip
          size="small"
          label="VERIFIED PR"
          style={{
            backgroundColor: "yellow",
          }}
        />
      );
    case 52:
      return (
        <Chip
          size="small"
          label="LEGAL MAKES A DECISION"
          style={{
            backgroundColor: "yellow",
          }}
        />
      );
    case 53:
      return (
        <Chip
          size="small"
          label="CONTRACT IS NOT REQUIRED"
          style={{
            backgroundColor: "yellow",
          }}
        />
      );
    case 54:
      return (
        <Chip
          size="small"
          label="LEGAL IN PROGRESS"
          style={{
            backgroundColor: "yellow",
          }}
        />
      );
    case 55:
      return (
        <Chip
          size="small"
          label="FINAL DRAFT IS DONE AND READY TO SIGN OFF"
          style={{
            backgroundColor: "yellow",
          }}
        />
      );
    case 56:
      return (
        <Chip
          size="small"
          label="CONTRACT IS ATTACHED"
          style={{
            backgroundColor: "yellow",
          }}
        />
      );
    case 57:
      return (
        <Chip
          size="small"
          label="LEGAL TASK IS COMPLETED"
          style={{
            backgroundColor: "yellow",
          }}
        />
      );
    case 58:
      return (
        <Chip
          size="small"
          label="CONTRACT IS REJECTED"
          style={{
            backgroundColor: "yellow",
          }}
        />
      );
    case 59:
      return (
        <Chip
          size="small"
          label="HELD BY LEGAL"
          style={{
            backgroundColor: "yellow",
          }}
        />
      );
    case 60:
      return (
        <Chip size="small" label="PURCHASING  COMPLETED" color="secondary" />
      );
    case 70:
      return (
        <Chip
          size="small"
          label="PURCHASING  HOLD"
          style={{
            backgroundColor: "gray",
            color: "white",
          }}
        />
      );
    case 80:
      return (
        <Chip
          size="small"
          label="PURCHASING REJECTED"
          style={{
            backgroundColor: "red",
          }}
        />
      );
    case 90:
      return <Chip size="small" label="OVER BUDGET" color="secondary" />;
    case 100:
      return <Chip size="small" label="PO GENERATED" color="secondary" />;
    default:
      return <Chip size="small" label="Not Defind" />;
  }
}
